import { useMutation } from 'react-query';
import mutationExportTable from './mutations/exportTable';
import mutationImportData from './mutations/importData';

const actionsDataTable = {
    // Export
    exportTable: (onSuccess, onError) => useMutation(mutationExportTable(onSuccess, onError)),
    // Import
    importData: (onSuccess, onError) => useMutation(mutationImportData(onSuccess, onError))
};

export default actionsDataTable;